export default "__VITE_ASSET__VJJqEMY3__"